import React from "react";
import "./CancellationPolicy.css"; // We'll define styles here
import SEO from "./SEO";

const CancellationPolicy = () => {
  return (
    <div className="policy-wrapper">
      <SEO
        title="Cancellation Policy"
        description="Understand our cancellation and refund policy for courses purchased on Edraak. Learn about eligibility, processing times, and how to request a cancellation."
        image=""
        url="https://edraakonline.com/cancellation-and-refund-policy"
      />
      <div className="policy-header">
        <h2>CANCELLATION/REFUND POLICY</h2>
      </div>
      <div className="policy-content">
        <ul>
          <li>Make sure that the courses are of their requirements before purchasing them.</li>
          <li>
            All purchases and payments made will be final and non-refundable, except where explicitly it is stated as part of ongoing marketing promotion.
            Users can evaluate the Services through the free trial provided on the App.
          </li>
          <li>
            In any case of special consideration provided by Edraak authorities, a cancellation request should be filed within 3 (Three) business days.
          </li>
          <li>
            All refunds, if eligible, will be processed within 14 (Fourteen) business days of receiving the cancellation request.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default CancellationPolicy;
